import { Injectable } from '@angular/core';
import { toast } from 'ngx-sonner';

export type SnackbarType = 'success' | 'error' | 'info' | 'warning';

@Injectable({
  providedIn: 'root',
})
export class SnackBarService {
  private show(message: string, type: SnackbarType = 'warning', duration = 3000): void {
    toast[type](message, {
      duration,
    });
  }

  success(message: string, duration = 3000) {
    this.show(message, 'success', duration);
  }

  error(message: string, duration = 3000) {
    this.show(message, 'error', duration);
  }

  warning(message: string, duration = 3000) {
    this.show(message, 'warning', duration);
  }

  info(message: string, duration = 3000) {
    this.show(message, 'info', duration);
  }

  dismissAll() {
    toast.dismiss();
  }
}
